import api from "../utils/api";

export const getExtrato = (
  startDateTimestamp,
  endDateTimestamp,
  recipient_id,
) => {
  let url = `https://api.prod.enercred.com.br/api/v1/extrato?start_date=${startDateTimestamp}&end_date=${endDateTimestamp}&recipient_id=${recipient_id}&status=available`;
  return api.get(url);
};

export const getExtratoDetails = (
  startDateTimestamp,
  endDateTimestamp,
  recipient_id,
) => {
  let url = `https://api.prod.enercred.com.br/api/v1/extrato/details?start_date=${startDateTimestamp}&end_date=${endDateTimestamp}&recipient_id=${recipient_id}&status=available&count=300`;
  return api.get(url);
};
